// Eric: This has to be this way until AngularJS and web-components no longer rely on this code
import { abbreviateNumber } from './abbreviated-number-with-suffix';
import { Formatter } from './formatter';
import { nfCurrencyTransform } from './nf-currency';

/**
 * TODO:  Workarround to keep consistency in name, remove it once all names were changed.
 * Do not use transform as name.
 */
export function transform(
  value: number | null,
  type: string,
  truncateValue = false,
  formatMoney: (arg1: number | null) => string,
  formatPercent: (arg1: number | null) => string,
  formatNumberInner: (arg1: number | null) => string,
  isSpendValue = false,
  operator = '',
  areRingChartNewRulesEnabled = false,
): string {
  return formatPlannedSpendLevel(
    value,
    type,
    truncateValue,
    formatMoney,
    formatPercent,
    formatNumberInner,
    isSpendValue,
    operator,
    areRingChartNewRulesEnabled,
  );
}

export function formatPlannedSpendLevel(
  value: number | null,
  type: string,
  truncateValue = false,
  formatMoney: (arg1: number | null) => string,
  formatPercent: (arg1: number | null) => string,
  formatNumberInner: (arg1: number | null) => string,
  isSpendValue = false,
  operator = '',
  areRingChartNewRulesEnabled = false,
): string {
  let formattedValue = '';

  if (value === null && !areRingChartNewRulesEnabled) {
    return 'N/A';
  }
  if (areRingChartNewRulesEnabled && isSpendValue && (!value || value <= 0)) {
    return '--';
  }

  switch (type) {
    case 'unitMarketShare':
    case 'dollarMarketShare':
      formattedValue =
        areRingChartNewRulesEnabled && value
          ? Formatter.percent(value)
          : formatPercent(value);
      break;
    case 'absoluteUnits':
      // use abbreviated format if truncateValue = true
      formattedValue = truncateValue
        ? abbreviateNumber(value)
        : formatNumberInner(value);
      break;
    case 'absoluteDollars':
      // use abbreviated format if truncateValue = true
      formattedValue = truncateValue
        ? '$' + abbreviateNumber(value)
        : nfCurrencyTransform(value, formatMoney);
      break;
    default:
  }

  return formattedValue;
}
